import React from 'react';
import { Container, CompletionCard, CenteredContainer, T1, Description } from '../../styles/SurveyStyles';

const SurveyAlreadyCompleted = ({ themeColors }) => {
  return (
    <Container themeColors={themeColors}>
      <CompletionCard>
        <CenteredContainer>
          <T1>Survey Already Completed</T1>
          <Description>
            You have already completed this survey. Thank you for your participation!
          </Description>
        </CenteredContainer>
      </CompletionCard>
    </Container>
  );
};

export default SurveyAlreadyCompleted; 